import {MutableRefObject, useEffect} from 'react';

export default function useOnClickOutside(ref: MutableRefObject<any>, handler: (outside: boolean) => void) {
  useEffect(() => {
    const listener = (event: MouseEvent | TouchEvent) => {
      handler(!(!ref.current || ref.current.contains(event.target)));
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]);
}
